"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadExperiments = exports.getEncounteredExperiments = exports.getExperimentAssignments = exports.isExperimentsReady = exports.$experimentsReady = exports.$experiments = void 0;
const nanostores_1 = require("nanostores");
const EMPTY_STATE = { assignments: {}, encountered: {}, paths: [] };
exports.$experiments = (0, nanostores_1.atom)(EMPTY_STATE);
exports.$experimentsReady = (0, nanostores_1.atom)(false);
const isExperimentsReady = () => exports.$experimentsReady.get();
exports.isExperimentsReady = isExperimentsReady;
const getExperimentAssignments = () => exports.$experiments.get().assignments;
exports.getExperimentAssignments = getExperimentAssignments;
const getEncounteredExperiments = () => exports.$experiments.get().encountered;
exports.getEncounteredExperiments = getEncounteredExperiments;
const DEFAULT_TIMEOUT_MS = 3000;
let loadPromise = null;
/**
 * Fetches the visitor's experiment assignment once and stores it. Always resolves and
 * flips $experimentsReady — on success, failure, or timeout — so it can never block the
 * consent gate / Segment load. Subsequent calls return the same in-flight/completed promise.
 */
const loadExperiments = (path, timeoutMs = DEFAULT_TIMEOUT_MS) => {
    // Single-flight and one-shot: a failed/empty load is cached intentionally (no retry) — the empty-but-ready store is the safe default for the consent gate.
    if (loadPromise) {
        return loadPromise;
    }
    loadPromise = (async () => {
        const controller = new AbortController();
        let timeoutId;
        const timeout = new Promise((_, reject) => {
            timeoutId = setTimeout(() => {
                controller.abort();
                reject(new Error('experiments fetch timed out'));
            }, timeoutMs);
        });
        try {
            // Keep parsing in this arm so the timeout covers both headers and body; catch suppresses
            // the abort rejection if the timeout wins.
            const fetchResult = fetch(`/api/experiments?path=${encodeURIComponent(path)}`, {
                signal: controller.signal,
            })
                .then(async (response) => {
                if (!response.ok) {
                    return;
                }
                const json = await response.json();
                const experiments = json.experiments ?? {};
                exports.$experiments.set({
                    assignments: experiments['pleo-split-test'] ?? {},
                    encountered: experiments['pleo-encountered-split-tests'] ?? {},
                    paths: experiments['pleo-split-test-paths'] ?? [],
                });
            })
                .catch(() => undefined);
            await Promise.race([fetchResult, timeout]);
        }
        catch {
            // Timeout or a malformed JSON body: leave $experiments empty. Silent graceful
            // degradation is intentional — experiment traits are best-effort enrichment.
        }
        finally {
            if (timeoutId !== undefined) {
                clearTimeout(timeoutId);
            }
            exports.$experimentsReady.set(true);
        }
    })();
    return loadPromise;
};
exports.loadExperiments = loadExperiments;
